import { motion } from "framer-motion";
import SectionLabel from "../site/SectionLabel";
import { HOME_SECTIONS } from "@/constants/testIds";
import { PROCESS_STEPS } from "@/lib/data";

export default function Process() {
  return (
    <section
      data-testid={HOME_SECTIONS.process}
      className="relative bg-ink-950 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <SectionLabel number="10">Process</SectionLabel>
        <h2 className="mt-6 max-w-3xl font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
          From business problem<br />
          <span className="italic text-gold">to business solution.</span>
        </h2>

        <div className="mt-16 grid grid-cols-1 divide-y divide-ivory/[0.06] border-y border-ivory/[0.06] md:grid-cols-4 md:divide-x md:divide-y-0">
          {PROCESS_STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="relative p-8 py-12 lg:p-10"
            >
              <div className="font-display text-5xl italic text-gold lg:text-6xl">{s.n}</div>
              <h3 className="mt-6 font-display text-3xl leading-tight tracking-tight text-ivory">
                {s.title}
              </h3>
              <p className="mt-4 font-sans text-sm leading-relaxed text-ivory-muted lg:text-base">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
